import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

function normalizeApiMessageWithFallbackKey(
  payload,
  fallbackMessage,
  fallbackKey,
) {
  const normalized = normalizeApiMessage(payload, fallbackMessage);
  return {
    ...normalized,
    messageKey: normalized.messageKey || fallbackKey || "",
  };
}

export async function postUpdateUser(info = {}) {
  if (
    !info ||
    typeof info !== "object" ||
    !info.id ||
    !info.password
  ) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Invalid user update request." },
        "Invalid user update request.",
        "api.user.update.validation.invalidRequest",
      ),
    };
  }

  let res;

  try {
    const path = `${BACKEND_URL}/user/update`;
    const formData = new FormData();

    formData.append("id", info.id);
    formData.append("email", info.email ?? "");
    formData.append("password", info.password ?? "");
    formData.append("newPassword", info.newPassword ?? "");
    formData.append("name", info.name ?? "");
    formData.append("removeSignatureImage", info.removeSignatureImage ? "true" : "false");

    if (info.signatureImage instanceof File) {
      formData.append("signatureImage", info.signatureImage);
    }

    res = await authFetch(
      path,
      {
        method: "POST",
        body: formData,
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );
  } catch (error) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Network error occurred." },
        "Network error occurred.",
        "api.common.networkError",
      ),
    };
  }

  let result = null;
  try {
    result = await res.json();
  } catch {
    result = null;
  }

  if (!result) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Failed to parse server response." },
        "Failed to parse server response.",
        "api.common.serverError",
      ),
    };
  }

  if (!res.ok || result?.success !== true) {
    const fallbackKey =
      res.status === 401
        ? "api.auth.token.expired"
        : res.status === 404
          ? "api.auth.user.notFound"
          : res.status === 409
            ? "api.user.update.emailConflict"
            : res.status === 400
              ? "api.user.update.validation.invalidRequest"
              : "api.user.update.failed";

    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        result,
        "Failed to update user settings.",
        fallbackKey,
      ),
    };
  }

  return {
    success: true,
    user: result?.user ?? null,
    ...normalizeApiMessageWithFallbackKey(
      result,
      "User settings updated successfully.",
      "api.user.update.success",
    ),
  };
}
